// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectReloadHistoryMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_HISTORY_CHANGED_RANGE);
        this.instrumentTradableID = null;
        this.instrumentId = null;
        this.routeID = null;
        this.historyPeriod = null;
        this.barsType = null;
    }
}
